module.exports = __webpack_public_path__ + "static/media/questionmark.3af5addc.svg";